import { render, staticRenderFns } from "./imprPop.vue?vue&type=template&id=a53a533e"
import script from "./imprPop.vue?vue&type=script&lang=js"
export * from "./imprPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53a533e')) {
      api.createRecord('a53a533e', component.options)
    } else {
      api.reload('a53a533e', component.options)
    }
    module.hot.accept("./imprPop.vue?vue&type=template&id=a53a533e", function () {
      api.rerender('a53a533e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprPop.vue"
export default component.exports